import axios from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};


//add an integration
const addIntegration = async ({ data, testSuiteId }) => {
  const user = getUserDetails();
  const response = await axios.post(
    `${API_BACKEND_URL}/testsuite/${testSuiteId}/integration?companyid=${user.companyid}`,
    data,

  );
  return response.data;
};

export const useAddIntegration = (options = {}) => {
  return useMutation({
    mutationFn: addIntegration,
    ...options,
  });
};


